import { HttpErrorResponse } from "@angular/common/http";

export const isUniqueError = (err: HttpErrorResponse) => {
	return /duplicate name/i.test(err.error);
};
export default {
	isUniqueError,
};
